import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '@univacity/angular/datas';
import { AngularUiModule, Menu } from '@univacity/angular/ui';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { getDasboardMenu } from '../dashboard-menu';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'un-dashboard-layout',
  imports: [NzLayoutModule, AngularUiModule, RouterModule, HeaderComponent],
  templateUrl: './dashboard-layout.component.html',
  styleUrls: ['./dashboard-layout.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardLayoutComponent implements OnInit {
  menus: Menu[] = [];
  constructor(private auth: AuthService) {}

  ngOnInit(): void {
    // if (!this.auth.isStudent && this.settings.subMenu) {
    //   this.settings.subMenu.splice(1, 0, {
    //     size: 'small',
    //     text: $localize`Users`,
    //     link: RoutePath.dashboardUsers,
    //     icon: 'usergroup-add',
    //     iconTheme: 'outline',
    //     description: $localize`Manage users & permissions`,
    //   });
    //   this.settings.subMenu.splice(-1, 0, {
    //     size: 'small',
    //     text: $localize`Banks`,
    //     link: [RoutePath.dashboardSettings, RoutePath.intakes],
    //     icon: 'bank',
    //     iconTheme: 'outline',
    //     description: $localize`Manage your bank details.`,
    //   });
    // }
    // if (
    //   (this.auth.isAdmin || this.auth.isInstituteUser) &&
    //   this.settings.subMenu
    // ) {
    //   this.settings.subMenu.splice(
    //     1,
    //     0,
    //     {
    //       size: 'small',
    //       text: $localize`Campuses`,
    //       icon: 'home',
    //       iconTheme: 'outline',
    //       link: [RoutePath.dashboardSettings, RoutePath.intakes],
    //       description: $localize`Manage your admission intakes`,
    //     },
    //     {
    //       size: 'small',
    //       text: $localize`Intakes`,
    //       icon: 'deployment-unit',
    //       iconTheme: 'outline',
    //       link: [RoutePath.dashboardSettings, RoutePath.intakes],
    //       description: $localize`Manage your admission intakes`,
    //     },
    //     {
    //       size: 'small',
    //       text: $localize`Addons`,
    //       icon: 'appstore-add',
    //       iconTheme: 'outline',
    //       link: RoutePath.dashboardAgencies,
    //       description: $localize`Manage addon services.`,
    //     },
    //     {
    //       size: 'small',
    //       text: $localize`Features`,
    //       icon: 'control',
    //       iconTheme: 'outline',
    //       link: RoutePath.dashboardAgencies,
    //       description: $localize`Manage addon services.`,
    //     },
    //     {
    //       size: 'small',
    //       text: $localize`Agencies`,
    //       icon: 'deployment-unit',
    //       iconTheme: 'outline',
    //       link: RoutePath.dashboardAgencies,
    //       description: $localize`Manage Agencies.`,
    //     },
    //     {
    //       size: 'small',
    //       text: $localize`Institutes`,
    //       icon: 'bank',
    //       iconTheme: 'outline',
    //       link: RoutePath.dashboardInstitutes,
    //       description: $localize`Manage Institutes`,
    //     }
    //   );
    // }
    this.menus = getDasboardMenu(this.auth);
  }
}
